export default __webpack_public_path__ + "static/russian-2-a5b78b5e5a86ffe545a60d4993a77327.jpg";